import React from 'react';
import { withTranslation, Trans } from 'react-i18next';
import {Button, Modal, Header, Input, Message, Label} from 'semantic-ui-react';

import Utils from 'utils/Utils.js'
import LoadInline from 'modules/loading/LoadInline.js';
import {colors, fontSizes, spacings, shadow, buttons} from 'style';
import styleDef from './style.js';

var style = {
    ...styleDef,
    star: {
        color:colors.themeBlue,
        position: 'relative',
        top: '2px',
    },
};


const DailyLimitModal = ({t, 
                          value, 
                          valid,
                          onChange, 
                          onClose, 
                          onSubmit}) => (
    <Modal open style={style.content} onClose={onClose} size='tiny'>
        <Modal.Header>{t('dailylimit_modal_header')}</Modal.Header>
        <Modal.Content>
        <form onSubmit={onSubmit}>
            <Modal.Description>
                <div style={style.description}>{Utils.endlToBr(t('dailylimit_modal_description'))}</div>
                <Input labelPosition='left' type='number' value={value} onChange={onChange} placeholder={t('dailylimit_modal_placeholder')}>
                <Label><i style={style.star} className="icon-Optimollar"/></Label>
                <input />
                </Input>
                <br />
                {Boolean(value && value>=0) &&
                    <p>{t('daily_reward_per_user_info', {value:(value / 100 * 30).toFixed(2)})}</p>
                }
                <br />
                <br />
                <Button type='submit' style={style.button} disabled={!valid}>{t('dailylimit_modal_btn')}</Button>
            </Modal.Description>
        </form>
        </Modal.Content>
    </Modal>
);

export default withTranslation('rewards')(DailyLimitModal);
